import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from '@mui/material';

interface SCHCTemplateAccordionLayoutProps {
  title: string;
  children: any;
}
function SCHCTemplateAccordionLayout({
  title,
  children,
}: SCHCTemplateAccordionLayoutProps) {
  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>
          { title }
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        { children }
      </AccordionDetails>
    </Accordion>
  );
}

export default SCHCTemplateAccordionLayout;
